import cn from 'clsx';

interface FieldsetSupportTextProps {
  isInvalid?: boolean;
  supportText: string;
}

export const FieldsetSupportText = ({ isInvalid, supportText }: FieldsetSupportTextProps) => {
  return (
    <p
      className={cn('caption-small-regular whitespace-pre-wrap pt-tiny-medium', {
        'text-error-foreground-main': isInvalid,
        'text-neutral-foreground-low': !isInvalid
      })}
    >
      {supportText}
    </p>
  );
};
